<template>
  <div class="module sm-top-simple">
    <div class="sm-top-simple-sec">
      <header class="sm-header-simple">
        <a
          class="back"
          uigs="head_back"
          href="javascript:void(0);"
          @click="backPrev"
        />
        <h1>{{ headTitle }}</h1>
        <a
          :href="'/?source=node&spver=' + spver"
          class="home"
          uigs="head_home"
        />
        <a
          :href="'/hotsugg?spver=' + spver"
          class="search"
          uigs="head_search"
        />
      </header>
      <div class="sm-info-img-simple">
        <div :class="[spver === 1 ? 'default-film' : 'default-sogou']">
          <img
            :src="$parent.getResizePicUrl(item.v_picurl, 60, 'auto', 200839)"
            alt
          >
        </div>
      </div>
      <figure class="sm-info-box-simple">
        <figcaption v-if="item.name">
          {{ item.name }}
        </figcaption>
        <p
          v-if="tag && tag.length"
          class="sm-info-tag-simple"
        >
          <template v-for="(v, index) in tag">
            <a
              :key="index"
              href="javascript:void(0);"
            >{{ v }}</a>
            <em
              v-if="index !== tag.length - 1"
              :key="index"
            >/</em>
          </template>
        </p>
        <p
          v-if="item.starring && typeof item.starring !== 'undefined'"
          class="sm-info-tag-simple"
        >
          <span>主演：</span>
          <template v-for="(str, index) in item.starring.split(';')">
            <em
              v-if="index !== 0"
              :key="index"
            >、</em>
            <a
              :key="index"
              href="javascript:void(0);"
            >{{ str }}</a>
          </template>
        </p>
      </figure>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getSpver } from '../../common/js/util';

export default {
  data() {
    return {
      backStatus: false,
    };
  },
  computed: {
    ...mapState('summary', ['itemData', 'pagemeta']),
    item() {
      return this.itemData;
    },
    tag() {
      const tag = [];
      const item = this.itemData;
      if (item) {
        if (item.year) {
          tag.push(item.year);
        }
        if (item.zone) {
          let zone = item.zone.split(';');
          if (zone.length) {
            [zone] = zone;
          }
          tag.push(zone);
        }
        if (item.style) {
          const style = item.style.split(';');
          if (style && style.length > 0) {
            tag.push(style[0]);
          }
          if (style && style.length > 1) {
            tag.push(style[1]);
          }
        }
      }
      return tag;
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
    headTitle() {
      const dockey = this.itemData.dockey || '';
      if (dockey.indexOf('film') > -1) {
        return '电影';
      }
      if (dockey.indexOf('teleplay') > -1) {
        return '电视剧';
      }
      return '';
    },
  },
  mounted() {
    this.setTitle();
  },
  methods: {
    searchResultUrl(string) {
      return `https://m.sogou.com/web/searchList.jsp?keyword=${string}&ie=utf8&pid=sogou-waps-4c26774d852f6244`;
    },
    backPrev() {
      history.go(-1);
      return false;
    },
    setTitle() {
      document.title = this.pagemeta.title;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.sm-top-simple-sec {
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 16px;
}

.sm-top-simple {
  padding: 0 14px;
  position: relative;
  border-bottom: 8px solid #f5f5f5;
  //margin-bottom: 20px;
}

.sm-header-simple {
  height: 57px;
  line-height: 57px;
  text-align: center;
  color: #555;
  font-size: 15px;
  position: relative;

  .back {
    @include sprite-item('detail/back_b');
    @extend %-vertical-center;
    left: 0;
    z-index: 9;
  }
  .home {
    @include sprite-item('detail/home_b');
    @extend %-vertical-center;
    right: 51px;
  }
  .search {
    @include sprite-item('detail/search_b');
    @extend %-vertical-center;
    right: 6px;
  }
}

.sm-info-box-simple {
  color: #222;
  height: 85px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  figcaption {
    @include line-clip(2);
    font-size: 17px;
    line-height: 23px;
    margin-bottom: 9px;
    font-weight: bold;
    //margin-top: -4px;
  }
}

.sm-info-img-simple {
  width: 60px;
  height: 85px;
  float: left;
  margin-right: 12px;
  position: relative;
  border-radius: 3px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.sm-info-tag-simple {
  @include line-clip(1);
  margin-bottom: 7px;
  color: #555;
  font-size: 13px;
  padding-top: 1px;
  padding-bottom: 1px;

  a {
    color: #555;
    font-size: 13px;
    margin: 0 3px;
  }

  a:first-of-type {
    margin-left: 0;
  }
}
</style>
